import React from 'react';
import PropTypes from 'prop-types';
import { LocaleUtils } from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import { Button } from '@material-ui/core';

class YearMonthForm extends React.Component {
  static getDerivedStateFromProps(props, state) {
    if (props.monthSelected !== state.monthSelected || props.yearSelected !== state.monthSelected) {
      return { monthSelected: props.monthSelected, yearSelected: props.yearSelected };
    }
    return null;
  }
  constructor(props) {
    super(props);
    this.state = {
      monthSelected: this.props.monthSelected,
      yearSelected: this.props.yearSelected,
    };
  }

  render() {
    const fromMonth = new Date(2015, 0, 1);
    const toMonth = new Date(2040, 11, 31);
    const months = LocaleUtils.getMonths();

    const { monthSelected, yearSelected } = this.state;

    const years = [];
    for (let i = fromMonth.getFullYear(); i <= toMonth.getFullYear(); i += 1) {
      years.push(i);
    }
    return (
      <form className="DayPicker-Header">
        <select name="month" onChange={this.props.handleMonthChange} value={monthSelected}>
          {months.map((month, i) => (
            <option key={month} value={i}>
              {month}
            </option>
          ))}
        </select>
        <select name="year" onChange={this.props.handleYearChange} value={yearSelected}>
          {years.map(year => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
        <Button variant="contained" color="primary" size="small" onClick={this.props.onToday}>
          Today
        </Button>
      </form>
    );
  }
}

YearMonthForm.propTypes = {
  onToday: PropTypes.func.isRequired,
  handleMonthChange: PropTypes.func.isRequired,
  handleYearChange: PropTypes.func.isRequired,
  monthSelected: PropTypes.number.isRequired,
  yearSelected: PropTypes.number.isRequired,
};

export default YearMonthForm;
